/* eslint-disable @typescript-eslint/no-explicit-any */
import { isNumber } from "./isNumber";
import { isString } from "./isString";

/**
 * Checks if a given character is an alpha (a-z)
 * @param char - The character to check
 * @returns boolean - True if the character is an alpha char, false otherwise
 */
export function isAlpha(char: any): boolean {
  return (
    (isString(char) || isNumber(char)) && /^[a-zA-Z]$/.test(char.toString())
  );
}
